import { useEffect, useState } from 'react'
import { useLanguage } from '@context/LanguageContext'
import styles from './UpdateBanner.module.css'

export default function UpdateBanner () {
  const [showBanner, setShowBanner] = useState(false)
  const { t } = useLanguage()

  useEffect(() => {
    const onUpdate = () => setShowBanner(true)
    window.addEventListener('sw-update', onUpdate)
    return () => window.removeEventListener('sw-update', onUpdate)
  }, [])

  if (!showBanner) return null

  return (
    <div
      className={styles.updateBanner}
      role='alert'
      aria-live='assertive'
    >
      <p>{t.core.update.message}</p>
      <p className={styles.instruction}>
        {t.core.update.instruction}
      </p>
      <button
        onClick={() => window.location.reload()}
        className={styles.button}
        aria-label={t.core.update.button}
      >
        {t.core.update.button}
      </button>
    </div>
  )
}
